/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { Text } from '@/primitives/Text';

import './SubtenantsHierarchy.css';

export function NoSubtenants() {
  const { t } = useMimicTranslation('subtenants');
  return (
    <div className="subtenant-placeholder">
      <Text>{t('noSubtenants')}</Text>
    </div>
  );
}
